<main class="multi-step">
  <!-- Step 1: Welcome Screen -->
  <section class="multi-step__step" *ngIf="currentStep === 1">
    <div class="welcome">
      <div class="welcome__content">
        <span class="welcome__title">Welcome to INSCYD</span>
        <p class="welcome__description">
          Let's create your first metabolic profile. If you have no real test data yet, you can start by reviewing example data
          - here you can also learn the application of the data in training.
        </p>
        <button
          type="button"
          class="welcome__button"
          mat-raised-button
          color="primary"
          (click)="onGetStarted()">
          Let's Get Started
        </button>
      </div>
    </div>
  </section>

  <!-- Step 2: Radio Selection Screen -->
  <section class="multi-step__step" *ngIf="currentStep === 2">
    <div class="selection">
      <div class="selection__header">
        <div class="selection__welcome">
          <span class="selection__title">Welcome to INSCYD</span>
          <p class="selection__description">
            Let's create your first metabolic profile. If you have no real test data yet, you can start by reviewing example data
            - here you can also learn the application of the data in training.
          </p>
          <button
            type="button"
            class="selection__header-button background-button-disabled"
            mat-stroked-button>
            Let's Get Started
          </button>
        </div>
      </div>

      <div class="selection__content">
        <span class="selection__question">How Would You Like to Start?</span>
        <p class="selection__subtitle u-margin-bottom-30">Please chose the type of data you want to proceed with:</p>
        <mat-radio-group
          color="primary"
          class="selection__radio-group"
          [(ngModel)]="selectedRadioValue">
          <mat-radio-button
            *ngFor="let option of radioOptions"
            class="selection__radio-button"
            [value]="option.value">
            {{ option.label }}
          </mat-radio-button>
        </mat-radio-group>

        <div class="selection__actions">
          <button class="width-49-percent" mat-raised-button (click)="onCancel()" type="button">Cancel</button>
          <button [disabled]="!selectedRadioValue" class="u-position-relative width-49-percent" mat-raised-button color="primary" (click)="onContinue()">Continue</button>
        </div>
      </div>
    </div>
  </section>

  <!-- Step 3: Tiles Display Screen -->
  <section class="multi-step__step u-padding-16 u-border-radius" *ngIf="currentStep === 3">
    <div>
      <header class="u-margin-bottom-10">
        <button
          type="button"
          class="u-font-weight-500 u-font-size-14"
          mat-raised-button
          (click)="onBackToPrevious()">
          Back to Previous
        </button>
      </header>

      <div class="tiles__content">
        <span class="u-display-block u-font-weight-500 u-font-size-18 u-margin-bottom-4">Provide Athlete Data</span>
        <p class="u-font-weight-400 u-font-size-14 u-margin-bottom-10 feature-detail-second-color tiles__subtitle">Select an example athlete to explore</p>

        <app-tile *ngFor="let feature of tiles" class="u-display-inline-block u-margin-right-20 u-margin-bottom-20" [config]="feature"></app-tile>
      </div>
    </div>
  </section>
</main>
